export const withAlphaHex = (hex: string, alphaHex: string) => `${hex}${alphaHex}`;
